module.exports = __webpack_public_path__ + "static/assets/bb530f4b897a380c87c1041521e7519d.png";